<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"   :pageData="pageData"></table-page>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import Url from '@/views/proxy/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil'
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
    },
    methods: {
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.queryData.platform = (this.flag == 1?"BO":"GTS2");
          this.$refs.childTable.defaultQueryData(data);
        }
      },
    },
    data () {
      return {
        flag:DateUtil.getParamKey(this.$route.params),
        queryData:{},
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
            { title: '代理编码', field: 'agentCode'},
            { title: '代理名称', field: 'name'},
            { title: '开始时间', field: 'startTime',type:5},
            { title: '结束时间', field: 'endTime',type:5},
            {click:"查询"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.adAgent.creditRecord.list, //请求路径和参数
          sequence: true,
          cols: [
            { title: '代理编码', field: 'agentCode'},
            { title: '关联交易账号', field: 'agentNumber'},
            { title: '代理名称', field: 'name'},
            { title: '授信前额度', field: 'creditLineBefore'},
            { title: '授信额度', field: 'creditLine'},
            { title: '授信后额度', field: 'creditLineAfter'},
            { title: '提案号', field: 'proposalNo'},
            { title: '审批人', field: 'approvalUser'},
            { title: '审批时间', field: 'approvalTime', render: (data, full) => {
                return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
              }},
        ]
        }
      }
    }
  }
</script>
